import { useMemo } from "react";
import type { Summary, TranscriptRecord } from "../types";

const SummaryBox = ({ transcriptData }: { transcriptData: TranscriptRecord[] }) => {
  const summary: Summary | undefined = useMemo(() => {
    const summaryItems = transcriptData.filter((item) => item.type === "summary");

    if (summaryItems.length === 0) {
      return undefined;
    }
    try {
      if (summaryItems[0]?.content) {
        return JSON.parse(summaryItems[0].content) as Summary;
      }
      return undefined;
    } catch {
      return undefined;
    }
  }, [transcriptData]);

  if (!summary) {
    return <div>No summary found.</div>;
  }

  return (
    <div className={"fs-standard"}>
      <span className={`fs-3 fw-bold`}>Call Summary</span>
      <ul>
        {summary["Call Summary"].map((summaryItem, index) => (
          <li key={index}>{summaryItem}</li>
        ))}
      </ul>
    </div>
  );
};

export default SummaryBox;
